export default __webpack_public_path__ + "static/media/astri.6b78d6f9.png";